<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8.29,7.71C8.29,7.71,11.29,10.71,11.29,10.71C11.47,10.89,11.72,11,12,11C12.28,11,12.53,10.89,12.71,10.71C12.71,10.71,15.71,7.71,15.71,7.71C15.89,7.53,16,7.28,16,7C16,6.45,15.55,6,15,6C14.72,6,14.47,6.11,14.29,6.29C14.29,6.29,13,7.59,13,7.59C13,7.59,13,1,13,1C13,0.45,12.55,0,12,0C11.45,0,11,0.45,11,1C11,1,11,7.59,11,7.59C11,7.59,9.71,6.29,9.71,6.29C9.53,6.11,9.28,6,9,6C8.45,6,8,6.45,8,7C8,7.28,8.11,7.53,8.29,7.71C8.29,7.71,8.29,7.71,8.29,7.71ZM14.5,13C14.5,13,1.5,13,1.5,13C0.67,13,0,13.67,0,14.5C0,15.33,0.67,16,1.5,16C1.5,16,14.5,16,14.5,16C15.33,16,16,15.33,16,14.5C16,13.67,15.33,13,14.5,13C14.5,13,14.5,13,14.5,13ZM1,5C1.28,5,1.53,4.89,1.71,4.71C1.71,4.71,3,3.41,3,3.41C3,3.41,3,10,3,10C3,10.55,3.45,11,4,11C4.55,11,5,10.55,5,10C5,10,5,3.41,5,3.41C5,3.41,6.29,4.7,6.29,4.7C6.47,4.89,6.72,5,7,5C7.55,5,8,4.55,8,4C8,3.72,7.89,3.47,7.71,3.29C7.71,3.29,4.71,0.29,4.71,0.29C4.53,0.11,4.28,0,4,0C3.72,0,3.47,0.11,3.29,0.29C3.29,0.29,0.29,3.29,0.29,3.29C0.11,3.47,0,3.72,0,4C0,4.55,0.45,5,1,5C1,5,1,5,1,5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Changes',
} as DefineComponent
</script>
